import { registerPlugin } from '@capacitor/core';
import type { HealthKitSample } from '@vitalai/health-normalizer';

export interface HealthKitAvailability {
  available: boolean;
}

export interface HealthKitAuthorizationResult {
  granted: boolean;
}

export interface HealthKitQueryOptions {
  /** epoch millis */
  startDate: number;
  /** epoch millis */
  endDate: number;
}

export interface HealthKitQueryResult {
  samples: HealthKitSample[];
}

export interface HealthKitPluginInterface {
  isAvailable(): Promise<HealthKitAvailability>;
  requestAuthorization(): Promise<HealthKitAuthorizationResult>;
  queryDailyMetrics(options: HealthKitQueryOptions): Promise<HealthKitQueryResult>;
}

const NATIVE_ONLY_MESSAGE = 'HealthKit solo esta disponible dentro de la app nativa de iOS, no en el navegador.';

/**
 * Implementacion web: se activa automaticamente fuera de un WebView nativo
 * de Capacitor (ej. `npm run dev`, o la PWA de escritorio). VitalAI nunca
 * intenta acceder a HealthKit desde el navegador.
 */
class HealthKitWeb implements HealthKitPluginInterface {
  async isAvailable(): Promise<HealthKitAvailability> {
    return { available: false };
  }

  async requestAuthorization(): Promise<HealthKitAuthorizationResult> {
    throw new Error(NATIVE_ONLY_MESSAGE);
  }

  async queryDailyMetrics(): Promise<HealthKitQueryResult> {
    throw new Error(NATIVE_ONLY_MESSAGE);
  }
}

/**
 * Puente hacia `HealthKitPlugin.swift` (ios/App/App/Plugins). En iOS, Capacitor
 * enruta estas llamadas al plugin nativo; en cualquier otro entorno usa
 * HealthKitWeb.
 */
export const HealthKit = registerPlugin<HealthKitPluginInterface>('HealthKit', {
  web: () => new HealthKitWeb(),
});
